import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignInComponent } from './sign-in/sign-in.component';
import {MatTabsModule} from '@angular/material/tabs';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { EmployerSignUpComponent } from './sign-up/employer-sign-up/employer-sign-up.component';
import { CandidateSignUpComponent } from './sign-up/candidate-sign-up/candidate-sign-up.component';
import {MatInputModule} from '@angular/material/input';
import { HttpClientModule } from '@angular/common/http';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { SharedModule } from '../shared/shared.module';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { RouterModule } from '@angular/router';
import {MatCheckboxModule} from '@angular/material/checkbox';

@NgModule({
  schemas:[CUSTOM_ELEMENTS_SCHEMA],
  declarations: [SignInComponent, EmployerSignUpComponent, CandidateSignUpComponent, ForgotPasswordComponent],
  imports: [
    CommonModule,
    MatTabsModule,
    FormsModule,
    AngularFireAuthModule,
    MatInputModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSnackBarModule,
    SharedModule,
    RouterModule,
    MatCheckboxModule
  ]
})
export class AuthModule { }
